<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Completed Compliance'"
      [canGoBack]="true"
      [customBack]="'compliance'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true">
    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <ion-img
            [src]="'assets/svg/arrow-back-black.svg'"
            class="desktop-back-icon"
            (click)="goBack()" />
          <tidy-text [title]="'Completed Compliance'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/img/search-header.svg'"
              class="header-search" />
          </form>
          <tidy-header-select
            [items]="addressItems"
            [(ngModel)]="selectedPropertyValue"
            (optionChange)="onDesktopPropertyChange()"
            [icon]="'assets/svg/home-outline.svg'" />
        </div>
        <div class="non-wrappable-right-aligned-container">
        </div>
      </tidy-desktop-header>
    }

    @if (!windowService.isDesktopRes) {
      @if (loaded) {
        <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 10px;">
          <div style="flex: 1; min-width: 0;">
            <form [formGroup]="form" novalidate action="#">
              <tidy-search-input
                formControlName="search"
                [placeholder]="'Search'"
                [icon]="'assets/img/search-header.svg'"
                class="header-search" />
            </form>
          </div>
        </div>
        <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 10px; flex-wrap: wrap;">
          <tidy-header-select
            [items]="addressItems"
            [(ngModel)]="selectedPropertyValue"
            (optionChange)="onDesktopPropertyChange()"
            [icon]="'assets/svg/home-outline.svg'" />
        </div>
      }
    }

    @if (!loaded && !windowService.isDesktopRes) {
      <div style="width: 100%; margin-bottom: 12px;">
        <ion-skeleton-text animated="true" style="height: 40px; border-radius: 6px" />
      </div>
      <div style="width: 100%; margin-bottom: 8px;">
        <ion-skeleton-text animated="true" style="height: 36px; border-radius: 4px" />
      </div>
      @for (i of [1,2,3,4,5]; track i) {
        <div style="width: 100%; margin-bottom: 6px;">
          <ion-skeleton-text animated="true" style="height: 44px; border-radius: 4px" />
        </div>
      }
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded && windowService.isDesktopRes) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded && selectedAddressId && windowService.isDesktopRes) {
      @if (shownRows.length) {
        <tidy-table
          [dataSource]="shownRows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          (sortChange)="sortChanged($event)"
          [showColumnLines]="false"
          [rowsToShow]="50"
          [allRowIsClickable]="true"
          (cellClick)="onTableColumnClick($event)"
          [skipEntrance]="true"
          [blockSorting]="true" />
      }
      @if (!shownRows.length) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No completed compliance items found.'" />
          </tidy-row>
        </tidy-alert>
      }
    }

    @if (loaded && selectedAddressId && !windowService.isDesktopRes) {
      @if (complianceItems.length) {
        @for (item of complianceItems; track item.id) {
          <tidy-card>
            <tidy-card-button
              (action)="goToItemDetail(item.id)"
              class="arrow-to-top">
              <tidy-row>
                <tidy-text [header]="(item.is_tax && item.name) ? item.name + (' (Tax)' | translate) : (item.name || item.what_to_do || 'Compliance item')" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-image [src]="'assets/svg/checkmark-circle-outline.svg'" class="body-size" />
                <tidy-text
                  [body]="'Completed'"
                  [ngStyle]="{ color: '#2E7D32' }" />
              </tidy-row>
              @if (item.frequency) {
                <tidy-row class="vertical-align-center">
                  <tidy-image [src]="'assets/svg/repeat-outline.svg'" class="body-size" />
                  <tidy-text [helper]="formatFrequency(item.frequency)" />
                </tidy-row>
              }
              @if (item.next_due_at) {
                <tidy-row class="vertical-align-center">
                  <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="body-size" />
                  <tidy-text [helper]="('Due: ' | translate) + (item.next_due_at | date:'MMM d, yyyy')" />
                </tidy-row>
              }
            </tidy-card-button>
          </tidy-card>
        }
      }
      @if (!complianceItems.length) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No completed compliance items found.'" />
          </tidy-row>
        </tidy-alert>
      }
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />
